import { createActions, createReducer } from 'reduxsauce'

import TipoRecursosVinculadosService from '../servicos/TipoRecursosVinculadosService'

/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
    buscaTipoRecursosVinculadosInicio: [],
    buscaTipoRecursosVinculadosSucesso: ['tipoRecursosVinculados'],
    buscaTipoRecursosVinculadosErro: ['erro'],
})

const INITIAL_STATE = {
    carregando: false,
    erro: null,
    lista: [],
}

// Ação para busca completa
Creators.buscaTipoRecursosVinculados = () => {
    return dispatch => {
        dispatch(Creators.buscaTipoRecursosVinculadosInicio())
        let serv = new TipoRecursosVinculadosService()
        return serv
            .getTipoRecursosVinculados()
            .then(response => dispatch(Creators.buscaTipoRecursosVinculadosSucesso(response.data)))
            .catch(error => dispatch(Creators.buscaTipoRecursosVinculadosErro(error)))
    }
}

const buscaTipoRecursosVinculadosInicio = (state = INITIAL_STATE, action) => ({ ...state, carregando: true, erro: null })

const buscaTipoRecursosVinculadosErro = (state = INITIAL_STATE, action) => ({ ...state, erro: action.erro, carregando: false })

const buscaTipoRecursosVinculadosSucesso = (state = INITIAL_STATE, action) => {
    return { ...state, lista: action.tipoRecursosVinculados, carregando: false }
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
    [Types.BUSCA_TIPO_RECURSOS_VINCULADOS_INICIO]: buscaTipoRecursosVinculadosInicio,
    [Types.BUSCA_TIPO_RECURSOS_VINCULADOS_ERRO]: buscaTipoRecursosVinculadosErro,
    [Types.BUSCA_TIPO_RECURSOS_VINCULADOS_SUCESSO]: buscaTipoRecursosVinculadosSucesso,
})
